<script>
    import { places_store, api_host } from '../../stores.js';
    import { init_data } from '../../init.js';
    import { querystring, push } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import Header from "../header.svelte";
    import IFTAInput from "../../utils/iftainput.svelte";
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from '../../utils/toast_message.js';
    import Swal from "sweetalert2";


    const { auth_type, auth_token, domain_code } = getToken();

    let working_cities = [];
    let selected_state = '';
    let psid = 0;
    let is_busy = false;
    let is_mounted = false;
    let is_new = false;
    let content_title = "Places - Cities";

    onMount(async () => {
        setTimeout(()=>{
            is_mounted = true;
            const params = new URLSearchParams($querystring);
            is_new = params.get("is_new") === 'first';
            if (is_new) {
                toast_message(true, "Add new city", 2000);
            }
        }, 250);

        init_data('places');
    });

    places_store.subscribe(value => {
        const params = new URLSearchParams($querystring);
        if (params.has("psid")) {
            psid = parseInt(params.get("psid"));
        }
        const states = Object.keys(value);
        selected_state = states.find(state => value[state].id === psid);
        if (selected_state) {
            content_title = `Places - Cities in ${selected_state}`;
            working_cities = value[selected_state].cities.map(_c => ({
                id: _c.id,
                c: _c.city,
                zipcodes: _c.zipcodes,
                z: (_c.zipcodes ?? []).join(', ')
            }));
        }
    });

    let show_new_city = false;
    let selected_id = 0;
    let new_city_name = "";
    let new_zipcodes = [];
    let temp_zipcode = "";

    function editCity(id) {
        const city = working_cities.find(_c => _c.id === id);
        show_new_city = true;
        new_city_name = city.c;
        new_zipcodes = city.zipcodes ?? [];
        selected_id = id;
    }

    async function addNewCity() {
        if (!new_city_name.length) {
            toast_message(false, "Please enter the city name.", 2000);
            return;
        }
        const _new_city_name = new_city_name.charAt(0).toUpperCase() + new_city_name.slice(1).toLowerCase();
        const res = await doFetch(
            `${api_host}/api/landscaper/update/city`,
            'POST',
            { id: selected_id, city_name: _new_city_name, state_id: psid, zipcodes: new_zipcodes },
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (res.status) {
            toast_message(true, res.msg, 2000);
            init_data('places');
            new_city_name = '';
            new_zipcodes = [];
            if (is_new) {
                setTimeout(() => {
                    push('#/Settingsdomain?is_new_user=true');
                }, 1000);
            }
        } else {
            toast_message(false, res.msg || 'Failed', 2000);
        }
    }

    async function deleteCity(state_id, id) {
        Swal.fire({
            title: 'Delete City?',
            buttonsStyling: true,
            confirmButtonClass: "button",
            confirmButtonText: 'OK',
            cancelButtonText: "Cancel",
            showCancelButton: true,
            icon: "success"
        }).then(async (e) => {
            if (e.isConfirmed) {
                const res = await doFetch(
                    `${api_host}/api/landscaper/delete/city`,
                    'POST',
                    { id, state_id: psid },
                    { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                );
                if (res.status) {
                    toast_message(true, res.msg, 2000);
                    init_data('places');
                } else {
                    toast_message(false, res.msg || 'Failed', 2000);
                }
            }
        });
    }

    let table_header_config = [
        {'t': 'City', 'fm': 'c', 'a': true},
        {'t': 'Zip Codes', 'fm': 'z', 'a': true},
    ];

    let action_items = [
        // {"id": "show", "i": "fas fa-eye", "s": "color: #1c54b2;", "f": (id) => {push("#/Invoice_Review?iid=" + id); }},
        {"id": "edit", "i": "fas fa-edit", "s": "color: #ff9800;", "f": (id) => {editCity(id);} },
        {"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": (id) => {deleteCity(psid, id)}},
    ];

</script>


<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="buttonholder">
        <button
            class='view_states'
            on:click={() => { push('#/Places'); }}
        >
            View States
        </button>
    </div>

    <div class="section">
        <div class="invoicetableholder">
            <ResponsiveTable 
                bind:table_header_config={table_header_config} 
                bind:table_data={working_cities} 
                num_per_page={100} 
                bind:total_items={working_cities.length} 
                action_items={action_items}
            />
        </div>        
    </div>

    <div class="buttonholder">
        <button on:click={() => {
            show_new_city = true;setTimeout(() => {
                if (document.getElementsByClassName("selectedcontentholder")[0]) {
                    document.getElementsByClassName("selectedcontentholder")[0].scrollTop = document.getElementsByClassName("selectedcontentholder")[0].scrollHeight;
                }
            }, 200);
        }}>New City</button>
    </div>
    {#if show_new_city}
    <div class="toolsholder highlight">
        <IFTAInput
            type="text"
            label="State"
            bind:value={selected_state}
            disabled={true}
        />
        <IFTAInput
            type="text"
            label="New City Name"
            bind:value={new_city_name}
            placeholder="eg. Springfield"
        />
        
        {#if new_zipcodes.length > 0}
        <div class="d-flex flex-column zipcode-list">
            <span class="small" style="color: #999; font-size: 12px;">Zip Codes</span>
            {#each new_zipcodes as zipcode, index}
            <div class="d-flex flex-row" style="justify-content: space-between; style: padding-top: 5px;">
                <span style="padding-right: 10px;">{zipcode}</span>
                <span>
                    <i class='fas fa-trash-alt' style='cursor: pointer;color: #ab003c;' on:click={() => {
                        Swal.fire({
                            title: 'Delete this zip code?',
                            buttonsStyling: true,
                            confirmButtonClass: "button",
                            confirmButtonText: 'OK',
                            cancelButtonText: "Cancel",
                            showCancelButton: true,
                            icon: "warning"
                        }).then((e) => {
                            if (e.isConfirmed) {
                                new_zipcodes.splice(index, 1);
                                new_zipcodes = new_zipcodes;
                            }
                        });
                    }}></i>
                </span>
            </div>
            {/each}
        </div>
        {/if}
        <IFTAInput
            type="text"
            label="Zip Code(Optional)"
            bind:value={temp_zipcode}
            placeholder=""
        />

        <div class="newitembuttonholder">
            {#if temp_zipcode.length}
            <button class="zipcodebutton" on:click={() => {
                new_zipcodes = [
                    ...new_zipcodes,
                    temp_zipcode
                ];
                temp_zipcode = "";
            }}>Add</button>
            {:else}
            <button class="savebutton" on:click={() => {addNewCity("new_expense");}}>Save</button>
            &nbsp;
            <button class="cancelbutton" on:click={() => {
                selected_id = 0;
                new_city_name = '';
                new_zipcodes = [];
                show_new_city = false;
            }} >Cancel</button>
            {/if}
        </div>
    </div>

    <div style="padding-left: 20px;">
        <p><strong>Note:</strong> Once specific ZIP codes are added, only those ZIP codes will show instant quote pricing on the booking page. All other ZIP codes will be excluded.
        <br />If no ZIP codes are added, all ZIP codes within the city will display instant quote pricing on your booking page.</p>
    </div>
    {/if}
</div>

<style>
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }

    :global(.rowwrap .group) {
        min-width: 200px;
        max-width: 200px;
    }
    .contentholder {
        padding: 0px;
    }

    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
        /* width: 100%; */
        background-color: #357a38;
        color: white;
    }
    .buttonholder button.view_states {
        background-color: #ff9100;
        margin-bottom: 10px;
    }
    :global(.flatpickr-input) {
        /* background-color: #ff9100; */
        /* color: white; */
        width: 250px;
    }
    .toolsholder {
        max-width: 1000px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;
    }

    :global(.toolsholder .group) {
        padding-left: 10px;
        padding-right: 10px;
    }
    .highlight {
        /* border: 1px solid black; */
        padding: 10px;
        box-sizing: border-box;
    }
    .newitembuttonholder {
        margin-left: 10px;
        width: 40%;
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }

    .newitembuttonholder button{
        max-width: 100px;
        width: 100px;
        height: 40px;
    }

    .newitembuttonholder button.savebutton{
        color: #1c54b2;
        background-color: white;
     }

    .newitembuttonholder button.cancelbutton{
        color: #b2102f;
        background-color: white;
    }
    .zipcode-list {
        margin: 13px 5px 8px 5px;
        padding: 10px 10px 5px 10px;
        border: solid 2px #ccc; 
        border-radius: 6px; 
        min-width: 130px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }

        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
        :global(.flatpickr-input) {
            /* background-color: #ff9100; */
            /* color: white; */
            width: 100%;
        }
        .toolsholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        :global(.toolsholder .group) {
            padding-left: 0px;
            padding-right: 0px;
        }

        .newitembuttonholder {
            margin-left: 0px;
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .newitembuttonholder button{
            max-width: 100%;
            width: 100%;
            height: 40px;
        }

        :global(.rowwrap .group) {
            min-width: 100%;
            max-width: 100%;
        }
    }
</style>